import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ManageLocaleWrapper = styled.div`
  padding-left: 16px;
  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
        }
      &:nth-child(n+2) {
        margin-top: 24px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
    margin-bottom: 16px;
  }

  .MuiInputBase-adornedEnd {
    background: ${COLORS.cirrus_black1};
  }

  .text-title {
    margin-bottom: 24px;
    margin-top: 32px;
    ${responsive.MOBILE`
       margin-bottom: 16px;
       margin-top: 16px;
    `}
  }
`;
